import { invokeApi } from "../../bl_libs/invokeApi";

export const addAppointmentApi = async (data) => {
  const requestObj = {
    path: `api/consultant/add_appointment`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const listAppointmentApi = async () => {
  const requestObj = {
    path: `api/consultant/appointment/list`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
